<template>
    <div v-if="!connected">
        <form action="" id="login-form" @submit.prevent="submitLogin" novalidate>
            <div class="as-logo-container"><img :src="logoRougeNoTextSrc" alt="Logo des As de l'info"></div>

            <input type="hidden"
                   id="recaptcha_token"
                   name="recaptcha_token"
                   v-model="loginFormData.recaptcha_token"/>

            <div class="input-group"
                 :class="formErrors.username ? 'has-errors' : ''">
                <label for="login-username">Nom d'utilisateur ou courriel<i
                    class="form-required-field-star">*</i></label>
                <input name="login-username"
                       id="login-username"
                       type="text"
                       autocomplete="username"
                       v-model="loginFormData.username"
                       @keydown="clearSingleFieldErrors('username')"
                       required>
                <form-error
                    v-if="formErrors.username"
                    :error="formErrors.username"
                ></form-error>

            </div>

            <div class="centered">
                <button class="btn-resend" v-if="strResendLink !== ''" type="button" @click="resendLink">
                    {{ copydeck?.btnResendConfirmation?.fr ?? 'Recevoir le lien de confirmation' }}
                </button>
            </div>

            <div class="input-group"
                 :class="formErrors.password ? 'has-errors' : ''">
                <label for="login-password">Mot de passe <i class="form-required-field-star">*</i></label>
                <input name="login-password"
                       id="login-password"
                       type="password"
                       autocomplete="password"
                       v-model="loginFormData.password"
                       @keydown="clearSingleFieldErrors('password')"
                       required>
                <form-error
                    v-if="formErrors.password"
                    :error="formErrors.password"
                ></form-error>

            </div>


            <div class="centered">
                <button type="submit" class="button btn-submit btn-submit-login" ref="btnLoginSubmit">
                    <span class="ajax-loader white centered"></span> <span>{{ copydeck?.btnLogin?.fr ?? '' }}</span>
                </button>
            </div>
        </form>

        <div class="centered text-links-container">
            <button type="button" class="text-link link-forgotten-password link-mode-toggle"
                    @click="changeMode('forgottenPassword')" v-html=" copydeck?.btnForgotPasswordToggle?.fr ?? '' ">
            </button>
            <!--            <br>-->
            <!--            <button type="button" class="text-link link-forgotten-password link-mode-toggle"-->
            <!--                    @click="changeMode('resendConfirmation')"-->
            <!--                    v-html=" copydeck?.btnResendConfirmationToggle?.fr ?? '' ">-->
            <!--            </button>-->
        </div>
        <div class="register-link-container">
            <button type="button" class="link-register link-show-all link-mode-toggle"
                    @click="changeMode('register')">{{ copydeck?.btnRegisterToggle?.fr ?? '' }}
            </button>
        </div>
    </div>

    <div class="connected-container success" v-if="connected">
        <div class="as-logo-container"><img :src="logoRougeNoTextSrc" alt="Logo des As de l'info"></div>
        <div class="content"
             v-html=" formResultAudience === 'jeunes' ? ( copydeck?.loginSuccessful?.fr ?? '' )  : ( copydeck?.loginSuccessfulProfs?.fr ?? '' )    "></div>

        <!--        <button ty pe="button" class="link-show-all btn" v-html="copydeck?.registerSuccessBtn?.fr ?? 'D\'accord!'"-->
        <!--                @click="reloadPage"></button>-->
    </div>
</template>

<script>
export default {
    name : "Login",
}
</script>

<script setup>

// Vue
import { ref, reactive, computed } from 'vue';
import { useStore }                from 'vuex';
import axios                       from 'axios';

// store
let store    = useStore();
let copydeck = computed( () => store.state.copydeck );


const logoRougeNoTextSrc = new URL( '../../../../images/logo-rouge-no-text.svg', import.meta.url ).href;


// composables
import { adjustHeaderConnect, changeMode, clearSingleFieldErrors } from '../composables';


// components
import FormError from './FormError.vue';


const loginFormData = reactive( {
    username        : '',
    password        : '',
    recaptcha_token : '',
} );

let formErrors     = computed( () => store.state.formErrors );
let btnLoginSubmit = ref( false );
let strResendLink  = ref( "" );
let connected      = computed( () => store.getters.isAutheticated );

let formResultAudience = ref( '' );

async function submitLogin ()
{

    btnLoginSubmit.value.disabled = true;
    btnLoginSubmit.value.classList.add( 'ajaxing' );


    try
    {
        const response = await axios.post( '/login', loginFormData );

        // 2023-10-24 We want to show the "success!! you've logged in!" message based
        // on the user's audience, not the current section's audience
        formResultAudience.value = response?.data?.user?.data?.audience ?? 'jeunes';

        store.commit( 'authenticateUser', response.data );
        store.commit( "hasBecomeLoggedIn" );

        // adjustHeaderConnect();

        const event = new Event( 'asUserAuthenticated' );
        window.dispatchEvent( event );


        setTimeout( () =>
        {
            store.commit( 'closeModal' );


            if ( response?.data?.redirectToProfile ?? false )
            {
                window.location = "/profil";

            } else if ( window.location.href.includes( 'mot-de-passe-oublie' ) || window.location.href.includes( 'courriel/verification' ) )
            {

                if ( "profs" === store.getters.audienceMode )
                {
                    window.location = "/profs";
                } else
                {
                    window.location = "/";
                }

            } else
            {


                if ( "profs" === store.getters.audienceMode )
                {
                    window.location = "/profs";
                } else
                {
                    window.location.reload();
                }
            }


        }, 2000 );

    }
    catch (error)
    {


        if ( error?.response?.data?.errors ?? false )
        {
            store.commit( 'addErrors', error.response.data.errors );

            if ( error.response.data.errors.link )
            {
                //strResendLink.value = error.response.data.errors.link[0];
                store.commit( "resendMessage", error.response.data.errors.username[ 0 ] );
                store.commit( "resendConfirmation", error.response.data.errors.link[ 0 ] );
                changeMode( "resendConfirmation" );
            }

        }
    }


    btnLoginSubmit.value.disabled = false;
    btnLoginSubmit.value.classList.remove( 'ajaxing' );
}

function resendLink ()
{
    axios.get( strResendLink.value );
    strResendLink.value = "";


}

function reloadPage ()
{
    window.location.reload();
}

</script>

<style scoped>

</style>
